import EcoSpace from 'eco-design/base/eco-space';
import { useState } from 'react';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoVideo from 'eco-design/base/eco-video';
import { getImgUrl } from '../../utils';
import Dialog from './dialog';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionD');
    const { locale = 'us' } = getLocal();
    const [show, setShow] = useState(false);
    const item = {
        jp: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1745378728519/video2.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745378633544/video2-f.jpg',
        },
        us: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744683038069/D.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1744874252254/video2.jpg',
        },
        ca: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1744766228735/video2-ss.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1744874270182/video2-ss.jpg',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1745720221774/uk.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745720221014/UK-Video.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1745720221774/uk.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745720221014/UK-Video.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1745720220621/fr.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745720221567/FR-Video.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1745720221200/de.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745720220234/DE-Video.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1745720221385/es.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745720220443/ES-Video.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1745720221952/it.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745720324540/IT-Video.jpg',
        },
        au: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1745720221774/uk.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1745720221014/UK-Video.jpg',
        },
    };
    return (
        <div id="SectionD">
            <EcoSpace />
            <EcoSectionCommon className={styles.section} label={t('label')} title={t('title')} desc={t('desc')} />
            <div className={styles.btn_container}>
                <div className={styles.btn} onClick={() => setShow(true)}>
                    {t('btn')}
                    <EcoIconArrow />
                </div>
            </div>
            <EcoSpaceSmall />
            <div className={styles.comp}>
                <EcoVideo className="demo-img-center" {...getImgUrl(item)} autoPlay loop />
            </div>
            <Dialog show={show} onClose={() => setShow(false)} />
        </div>
    );
}
